export enum ThemeType {
  MEMOIR = 'memoir'
}
